import { EntityDefinition } from '@/types/crud';

export const abacCustomAttributeEntity: EntityDefinition = {
  name: 'abacCustomAttribute',
  displayName: 'Custom Attributes',
  apiEndpoint: '/abac/custom-attributes',
  idField: 'id',
  nameField: 'attribute_name',
  copyable: false,
  deletable: true,
  searchable: true,
  sortable: true,
  pageSize: 20,
  tableColumns: [
    {
      key: 'attribute_name',
      label: 'Attribute Name',
      sortable: true,
      render: (value: any) => value || 'N/A'
    },
    {
      key: 'attribute_type',
      label: 'Type',
      sortable: true,
      render: (value: any) => value || 'N/A'
    },
    {
      key: 'data_type',
      label: 'Data Type',
      sortable: true,
      render: (value: any) => value || 'N/A'
    },
    {
      key: 'description',
      label: 'Description',
      sortable: false,
      render: (value: any) => value ? (value.length > 50 ? value.substring(0, 50) + '...' : value) : 'N/A'
    },
    {
      key: 'is_required',
      label: 'Required',
      sortable: true,
      render: (value: any) => value ? 'Yes' : 'No'
    },
    {
      key: 'is_active',
      label: 'Active',
      sortable: true,
      render: (value: any) => value ? 'Yes' : 'No'
    },
    {
      key: 'computation_type',
      label: 'Computation',
      sortable: true,
      render: (value: any) => value || 'N/A'
    },
    {
      key: 'default_value',
      label: 'Default Value',
      sortable: false,
      render: (value: any) => value || 'N/A'
    }
  ],
  fields: [
    {
      key: 'id',
      label: 'ID',
      type: 'text',
      hidden: true,
      order: 0
    },
    {
      key: 'attribute_name',
      label: 'Attribute Name',
      type: 'text',
      required: true,
      placeholder: 'Enter attribute name',
      order: 1
    },
    {
      key: 'attribute_type',
      label: 'Attribute Type',
      type: 'select',
      required: true,
      options: [
        { value: 'USER', label: 'User' },
        { value: 'RESOURCE', label: 'Resource' }
      ],
      defaultValue: 'USER',
      order: 2
    },
    {
      key: 'data_type',
      label: 'Data Type',
      type: 'select',
      required: true,
      options: [
        { value: 'STRING', label: 'String' },
        { value: 'NUMBER', label: 'Number' },
        { value: 'BOOLEAN', label: 'Boolean' },
        { value: 'DATE', label: 'Date' },
        { value: 'JSON', label: 'JSON' }
      ],
      defaultValue: 'STRING',
      order: 3
    },
    {
      key: 'description',
      label: 'Description',
      type: 'textarea',
      placeholder: 'Enter description',
      order: 4
    },
    {
      key: 'is_required',
      label: 'Required',
      type: 'boolean',
      defaultValue: false,
      order: 5
    },
    {
      key: 'is_active',
      label: 'Active',
      type: 'boolean',
      defaultValue: true,
      order: 6
    },
    {
      key: 'computation_type',
      label: 'Computation Type',
      type: 'select',
      options: [
        { value: 'STATIC', label: 'Static' },
        { value: 'DYNAMIC', label: 'Dynamic' },
        { value: 'COMPUTED', label: 'Computed' }
      ],
      defaultValue: 'STATIC',
      order: 7
    },
    {
      key: 'default_value',
      label: 'Default Value',
      type: 'text',
      placeholder: 'Enter default value',
      order: 8
    },
    {
      key: 'created_by_email',
      label: 'Created By',
      type: 'text',
      hidden: true,
      order: 9
    },
    {
      key: 'created_at',
      label: 'Created',
      type: 'datetime',
      hidden: true,
      order: 10
    }
  ]
};
